import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ASSETS } from "@/data/catalogue";
import { useSaved } from "@/data/useSaved";
import { applyRouteMode } from "@/styles/theme";
import ringSketch from "@/assets/images/ring.png";
import img07135 from "@/assets/images/07135.jpg";
import imgDrawing from "@/assets/images/121207.jpg";
import { StarIcon } from "@/assets/icons/StarIcon";
import { useNavState } from "@/navigation/useNavState";
import { detailHref } from "@/navigation/trail";
import "./Saved.css";

const IMAGES = [img07135, imgDrawing, ringSketch];
const getImage = (i: number) => IMAGES[i % IMAGES.length];

export default function Saved() {
  const { refs, toggle } = useSaved();
  const navigate = useNavigate();
  const state = useNavState();

  useEffect(() => {
    applyRouteMode("light");
  }, []);

  const saved = ASSETS.filter((a) => refs.has(a.ref));

  return (
    <div className="saved-page">
      {saved.length === 0 ? (
        <div className="saved-empty">
          <span className="saved-empty-star">☆</span>
          <p>Nessun asset salvato.</p>
          <p className="saved-empty-sub">
            Usa la stella accanto a un asset per aggiungerlo qui.
          </p>
        </div>
      ) : (
        <div className="saved-grid">
          {saved.map((asset, i) => (
            <div
              key={asset.ref}
              className="scard"
              style={{ animationDelay: `${1.3 + i * 0.05}s` }}
              onClick={() => navigate(detailHref(asset.ref, state))}
            >
              <div className="scard-img">
                <img src={getImage(i)} alt={asset.label} />
              </div>
              <div className="scard-body">
                <div className="scard-ref">{asset.ref}</div>
                <div className="scard-title">{asset.title}</div>
                <div className="scard-meta">
                  {asset.categoryLabel} · {asset.material}
                </div>
              </div>
              <button
                className="scard-star saved"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggle(asset.ref);
                }}
                aria-label="Rimuovi dai salvati"
              >
                <StarIcon size={16} filled />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
